export default __webpack_public_path__ + "static/media/bulgo-screenshot-01.66f5119b.png";